import { GtmVirtual } from './gtm.enums';

const basePath = '/virtual/purchase_path';

export class GtmHelper {
  static gtmUrl = (gtmCode: string) =>
    `https://www.googletagmanager.com/gtm.js?id=${gtmCode}&l=dataLayer`;
  static ga4Url = (ga4Code: string) =>
    `https://www.googletagmanager.com/gtag/js?id=${ga4Code}`;
}

export class VirtualPath {
  static fromSegments([...segments]: string[]): string {
    return `${basePath}/${segments.join('/')}`.replace('//', '/');
  }

  static fromString(path: string): string {
    return `${basePath}/${path}`.replace('//', '/');
  }
}

export const VirtualPathMap = new Map()
  .set(GtmVirtual.Empty, '/virtual/purchase_path/qqc')
  .set(GtmVirtual.Home, '/virtual/purchase_path/qqc')
  .set(GtmVirtual.AMT, '/virtual/purchase_path/qqc_amt')
  .set(GtmVirtual.Plans, '/virtual/purchase_path/select_plan')
  .set(GtmVirtual.Options, '/virtual/purchase_path/options')
  .set(GtmVirtual.Details, '/virtual/purchase_path/traveller_details')
  .set(GtmVirtual.Payment, '/virtual/purchase_path/payment')
  .set(GtmVirtual.Receipt, '/virtual/purchase_path/receipt');
